import moment from 'moment'

function dateFormat(date: Date, formatType: string): string {
  if (!date) {
    return date
  }
  let momentDate = moment(date, moment.ISO_8601).isValid() ? moment(date) : moment(new Date(date))

  switch (formatType) {
    case 'time_only':
      return momentDate.format('HH:mm')
    case 'time_only_with_am_pm':
      return momentDate.format('hh:mm A')
    case 'date_only':
      return momentDate.format('YYYY-MM-DD')
    case 'short_month_date':
      return momentDate.format('MMM DD')
    default:
      return momentDate.format('LLL')
  }
}

export { dateFormat }
